import optionTypes from '@/api/options/OptionTypes'

const getModuleName = (type) => type

export default {
    getters: {
        OPTIONS: 'options',
    },
    mutations: {
        OPTIONS: 'options',
        LOADER: 'loader',
        INVALIDATE: 'invalidate',
    },
    actions: {
        LOAD: 'load',
        REFRESH: 'refresh',
    },
    optionTypes,
    getModuleName,
    getActionName: (type, action) => `${getModuleName(type)}/${action}`,
}
